module.exports = __webpack_public_path__ + "ef3a8c15847d33e2ba8b323f5180f44f.MP3";